import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { installViewportHeightTracker } from './infra/viewportHeight';

// Mobile keyboard fix: Android Chrome / Samsung / MIUI don't shrink
// 100dvh when the on-screen keyboard opens, so the composer ends up
// half-hidden under the keyboard's suggestion bar. The tracker mirrors
// the live visual viewport height into `--app-vh` on `:root` so the
// chat layout can use `var(--app-vh)` instead of `100dvh` and stay
// fully visible above the keyboard. Installed once at boot — runs
// before the first React render so the initial paint already has the
// correct height.
installViewportHeightTracker();

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element with id "root" not found in index.html');
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
